import React, { useState } from 'react';
import logo from '../img/logo_m.png';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const [cpf, setCpf] = useState('');
  const [senha, setSenha] = useState('');
  const [mensagem, setMensagem] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
  e.preventDefault();
  setMensagem('');

  try {
    const response = await fetch('/api/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ cpf, senha }),
    });

    const data = await response.json();
    if (response.ok) {
      localStorage.setItem("usuario_id", data.id || "");
      localStorage.setItem("cnpj_corretora", data.cnpj_corretora || "");
      localStorage.setItem("cpf_usuario", data.cpf || "");
      localStorage.setItem("nome_usuario", data.nome || "");
      localStorage.setItem("tipo_usuario", data.tipo || "");  // <-- ESSENCIAL!
      localStorage.setItem("nome_corretora", data.nome_corretora || "");
      
      setMensagem('Login OK!');
      navigate("/dashboard");
    } else {
      setMensagem(data.detail || 'Login inválido');
    }
  } catch (err) {
    setMensagem('Erro ao conectar com o servidor.');
  }
};

  return (
    <div
      style={{
        height: '100vh',
        backgroundColor: '#f3f4f6',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          borderRadius: '1rem',
          padding: '1.5rem',
          width: '100%',
          maxWidth: '400px',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
          backgroundColor: 'transparent',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
          <img
            src={logo}
            alt="Logo ConectaAI"
            style={{
              width: '180px',
              height: 'auto',
              margin: '0 auto',
              display: 'inline-block',
            }}
          />
        </div>

        <form
          style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}
          onSubmit={handleSubmit}
        >
          <input
            type="text"
            placeholder="CPF"
            value={cpf}
            onChange={(e) => setCpf(e.target.value)}
            style={{
              padding: '0.5rem',
              borderRadius: '0.375rem',
              border: '1px solid #d1d5db',
              outline: 'none',
              fontSize: '1rem',
            }}
          />
          <input
            type="password"
            placeholder="Senha"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            style={{
              padding: '0.5rem',
              borderRadius: '0.375rem',
              border: '1px solid #d1d5db',
              outline: 'none',
              fontSize: '1rem',
            }}
          />
          <button
            type="submit"
            style={{
              backgroundColor: '#00bcd4',
              color: '#fff',
              padding: '0.5rem',
              borderRadius: '0.375rem',
              border: 'none',
              cursor: 'pointer',
              fontSize: '1rem',
            }}
            onMouseOver={e =>
              (e.currentTarget.style.backgroundColor = '#00a0b8')
            }
            onMouseOut={e =>
              (e.currentTarget.style.backgroundColor = '#00bcd4')
            }
          >
            Entrar
          </button>
          {mensagem && (
            <div style={{ color: 'red', textAlign: 'center' }}>{mensagem}</div>
          )}
        </form>
      </div>
    </div>
  );
}
